import * as React from 'react'

import Chart from "react-apexcharts";
import colors from '../../globals/colors';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { lang } from '../../globals/Translations';

export enum IconSizes {
  Small = "small",
  Large = "large",
  XLarge = "XLarge"
}


const state = (icon: IconSizes): ApexCharts.ApexOptions => ({
  chart: {
    animations: {
      speed: 3000
    }
  },
  plotOptions: {
    radialBar: {
      startAngle: -135, endAngle: 225,
      hollow: {
        size: '65%', margin: 0, background: colors.lighter,
        dropShadow: { enabled: true, top: 3, left: 0, blur: 4, opacity: 0.24 }
      },
      track: {
        background: colors.lighter, strokeWidth: '67%', margin: 0,
        dropShadow: { enabled: true, top: -3, left: 0, blur: 4, opacity: 0.35 }
      },

      dataLabels: {
        name: {
          offsetY: (icon === IconSizes.XLarge ? -20 : -10), color: colors.grayText,
          fontSize: (icon === IconSizes.XLarge ? 20 : 10) + 'px'
        },
        value: {
          formatter: function (val: number) { return val + "%"; },
          color: colors.dark,
          fontSize: (icon === IconSizes.XLarge ? 35 : 25) + 'px',
          show: true,
          offsetY: 0

        }
      }
    }
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'dark',
      type: 'horizontal',
      shadeIntensity: 0.5,
      gradientToColors: [colors.sucess],
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 100]
    }
  },
  stroke: { lineCap: 'round' },
  labels: [lang(TranslatedTerms.COMPLETED)],

})

const CompletionChart: React.FC<{ iconSize: IconSizes, percent: number }> = ({ iconSize, percent }) => {
  const localPercent = percent > 100 ? 100 : percent
  const Size = iconSize === IconSizes.Large ? 250 : IconSizes.XLarge ? 350 : 150

  return (
    <div style={{
      width: Size * 0.6, height: Size * 0.6, borderRadius: 100,
      display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center'
    }}>
      <Chart series={[localPercent]} type="radialBar" width={Size} height={Size} options={state(iconSize)}
      />
    </div>

  )
}

export default CompletionChart
